import { ComponentPropsWithRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface ProgressGPTContainerProps extends ComponentPropsWithRef<'div'> {}
const ProgressGPTContainer = forwardRef<HTMLDivElement, ProgressGPTContainerProps>((props, ref) => {
    const { children, className, ...rest } = props;

    return (
        <div ref={ref} className={twMerge('max-w-3xl w-full mx-auto px-4', className)} {...rest}>
            {children}
        </div>
    );
});

export default ProgressGPTContainer;
